import React from 'react';
import { reduxForm, Field } from 'redux-form';
import FormField from '../../forms/FormField';
import { Link } from 'react-router-dom';

const required = value => value ? undefined : 'Required';

const passwordMatch = (...props) => {
  const { password, password2 } = props[1] || {};

  return password !== password2 ? 'Passwords do not match.' : undefined;
};

const passwordLength = (...props) => {
  const { password } = props[1] || {};
  return password.length < 8
    ? 'Password must be at least 8 characters long.'
    : undefined;
};

const ResetPasswordForm = props => {
  const { handleSubmit, submitting, postResetPasswordError } = props;
  return (
    <form onSubmit={handleSubmit}>
      <Field
        name="email"
        type="email"
        component={FormField.Input}
        placeholder="Email"
        validate={[required]}
      />
      <Field
        name="password"
        type="password"
        component={FormField.Input}
        placeholder="New Password"
        validate={[required]}
      />
      <Field
        name="password2"
        type="password"
        component={FormField.Input}
        placeholder="Re-Enter New Password"
        validate={[required, passwordMatch, passwordLength]}
      />
      <div>
        <div className="form-row">
          <div className="col-md-12">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={submitting}
            >
              Submit
            </button>

            {postResetPasswordError &&
              <span style={{ color: '#dc3545', marginLeft: '20px' }}>
                This link is no longer valid. If you need to reset your password, please submit a new request.
              </span>}
            {/*
              {error &&
                <span style={{ color: '#dc3545', marginLeft: '20px' }}>
                  An error occurred reseting your password. Please verify the correct email address was entered and try again
                </span>}
              {success &&
                <span style={{ color: '#a69c80', marginLeft: '20px' }}>
                  Your password was successfully changed. Please return to the homepage and log in with your new password.
                </span>}
                
            */}
          </div>
        </div>
      </div>
    </form>
  );
};

export default reduxForm({
  form: 'reset-password-form'
})(ResetPasswordForm);
